import lazyLoad from "../../components/lazyLoad";
import animationCommon from "../common/animation";
import fixedHeader from "../common/fixedHeader";

export default function(currentPage) {
    return [
        lazyLoad.bind(null, 200),
        fixedHeader,

        animationCommon.bind(currentPage, [
            {
                name: 'footer',
                axis: 'x',
                oddAxis: true
            }
        ]),
    ];
}

